import styled from '@emotion/styled';
import { List, ListItem, Text } from '@qga/roo-ui/components';

const StyledList = styled(List)`
  ${ListItem} {
    flex-grow: 0;
  }
`;

const Facilities = ({ facilities }: { facilities: string[] }) => (
  <StyledList columns={[1, 2, 3]}>
    {facilities.map((facility) => (
      <ListItem key={facility} data-testid="FACILITY" mb="0">
        <Text fontSize={['sm', null, 'base']}>{facility}</Text>
      </ListItem>
    ))}
  </StyledList>
);

export default Facilities;
